declare namespace $ {

	type $mol_view__sub_bog_ui_sidebar_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_bog_ui_sidebar_2 = $mol_type_enforce<
		ReturnType< $bog_ui_sidebar['items_with_collapsed'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_ui_sidebar_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_ui_sidebar_4 = $mol_type_enforce<
		ReturnType< $bog_ui_sidebar['toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ui_sidebar_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $bog_ui_sidebar extends $mol_view {
		Header( ): $mol_view
		items_with_collapsed( ): readonly(any)[]
		Items( ): $mol_list
		Footer( ): $mol_view
		toggle( next?: any ): any
		Toggle_icon( ): $mol_icon_menu
		Toggle( ): $mol_button_minor
		mode( next?: string ): string
		items( ): readonly(any)[]
		sub( ): readonly(any)[]
		attr( ): ({ 
			'bog_ui_sidebar_mode': ReturnType< $bog_ui_sidebar['mode'] >,
		}) 
	}
	
}

//# sourceMappingURL=sidebar.view.tree.d.ts.map